module.exports = __webpack_public_path__ + "static/media/S16_black.08feca48.png";